import { createStore, applyMiddleware, combineReducers } from 'redux';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import thunk from 'redux-thunk';
import { createBrowserHistory } from 'history';
import { reducer as reduxFormReducer } from 'redux-form';
import { createLogger } from 'redux-logger';

import authReducer from './auth/authReducer';
import newsReducer from './news/newsReducer';

import client from './client';

const history = createBrowserHistory();
let middlewares = [thunk.withExtraArgument(client), routerMiddleware(history)];

if (process.env.NODE_ENV !== 'production') {
  const logger = createLogger({
    predicate: (getState, action) =>
      !(action.type && String(action.type).startsWith('@@redux-form')),
    collapsed: true,
  });
  middlewares.push(logger);
}

const reducers = combineReducers({
  router: connectRouter(history),
  form: reduxFormReducer,
  news: newsReducer,
  auth: authReducer,
});

const store = createStore(
  reducers,
  applyMiddleware(...middlewares),
);

export { store, history };
